<template>
  <a-input-number
    :value="innerValue"
    :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
    :default-value="field.defaultValue"
    :disabled="field.disabled"
    :formatter="field.formatter"
    :max="field.max"
    :min="field.min"
    :placeholder="field.placeholder ? field.placeholder : '请输入' + field.label"
    :precision="field.precision == null || field.precision === '' ? undefined : field.precision"
    :step="field.step"
    size="small"
    @update:value="update"
  >
    <template
      v-if="field?.prefix || field?.prefixIcon"
      #prefix
    >
      <span v-if="field?.prefix">{{ field.prefix }}</span>
      <component
        v-if="field?.prefixIcon"
        :is="field?.prefixIcon"
      />
    </template>
    <template
      v-if="field?.addonBefore || field?.addonBeforeIcon"
      #addonBefore
    >
      <span v-if="field?.addonBefore">{{ field.addonBefore }}</span>
      <component
        v-if="field?.addonBeforeIcon"
        :is="field?.addonBeforeIcon"
      />
    </template>
    <template
      v-if="field?.addonAfter || field?.addonAfterIcon"
      #addonAfter
    >
      <span v-if="field?.addonAfter">{{ field.addonAfter }}</span>
      <component
        v-if="field?.addonAfterIcon"
        :is="field?.addonAfterIcon"
      />
    </template>
  </a-input-number>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { normalizeFieldExtraAddonValue, stripFieldExtraAddonValue } from '../addonValue';

export default defineComponent({
  name: 'InputNumberPro',
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [Number, String],
      required: false,
      default: () => null,
    },
  },
  emits: ['update:value'],
  setup(props, { emit }) {
    const update = (value: string | number | null) => {
      emit('update:value', normalizeFieldExtraAddonValue(props.field, value));
    };
    const innerValue = computed(() => {
      let innerValue = stripFieldExtraAddonValue(props.field, props.value);
      if (typeof innerValue === 'string') {
        innerValue = parseFloat(innerValue);
        if (isNaN(innerValue)) {
          innerValue = null;
        }
      }
      return innerValue;
    });
    return { update, innerValue };
  },
});
</script>
<style lang="less" scoped>
.head_btn {
  display: flex;
  gap: 4px;
  justify-content: end;
  margin-bottom: 4px;
  flex-wrap: wrap;
}
</style>
